import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {PaymentRequestConfigurationModel} from "../../../api/entity/paymentRequestConfiguration.model";
import {AbstractRepositoryV2} from "../../../../../../../core/service/v2/abstractRepositoryV2";

@Injectable()
export class PaymentRequestConfigurationRepository extends AbstractRepositoryV2<PaymentRequestConfigurationModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('PaymentRequestConfiguration', serviceElementsFactory, injector);
    }
}
